import React, { Component } from 'react';
import { Button, Grid, Row, Table } from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import LoaderButton from '../components/LoaderButton';
import yyyymmdd from '../libs/date_convert';
import { invokeApig } from '../libs/awsLib';

export default class ViewEmptyChannels extends Component {
  constructor(props) {
    super(props);
    this.file = null;
    this.state = {
      isLoading: true,
      reportData: {},
      currentDate: new Date(),
      searchDate: yyyymmdd(new Date()),
      showPicker: true,
    };
    this.handleDateChangeV2 = this.handleDateChangeV2.bind(this);
    this.showDatePicker = this.showDatePicker.bind(this);
    this.getReportData = this.getReportData.bind(this);
  }

  showDatePicker() {
    this.setState({
      showPicker: !this.state.showPicker,
    });
  }

  async getReportData() {
    try {
      const test = await invokeApig({
        path: `/reports/emptychannel/${this.state.searchDate}`,
        method: 'GET',
      });
      this.setState({
        isLoading: false,
        reportData: test.body,
        showPicker: false,
      });
    } catch (e) {
      console.error(e);
    }
  }

  transformFromIDtoPretty(item) {
    const pattern = '_';
    const re = new RegExp(pattern, 'g');
    const str = item.replace(re, ' ').toLowerCase();
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  handleDateChangeV2(value) {
    this.setState({
      searchDate: yyyymmdd(value),
      currentDate: value,
    });
  }

  handleSave = () => {
    console.log('saved', this.state.m.format('llll'));
  };

  render() {
    let headers = [];
    let rows = [];
    headers = [
      <tr key="header-table">
        <th key="kioskName">Location</th>
        <th key="vendItemName">Item Name</th>
        <th key="timestamp">Timestamp</th>
        <th key="logicalColumn">Logical Column</th>
        <th key="logicalRow">Logical Row</th>
      </tr>,
    ];

    if (this.state.reportData.length > 0) {
      rows = this.state.reportData.map((header) => (
        <tr key={header.timestamp + header.kioskName}>
          <td>{header.kioskName}</td>
          <td>{header.vendItemName}</td>
          <td>
            {`${header.timestamp.slice(0, 10)} ${header.timestamp.slice(
              11,
              16,
            )}`}
          </td>
          <td>{header.logicalColumn}</td>
          <td>{header.logicalRow}</td>
        </tr>
      ));
    } else {
      rows = (
        <tr key="NO-Data">
          <td key="NO-Data"> No Data for this date</td>
        </tr>
      );
    }
    return (
      <div>
        {!this.state.showPicker && (
          <LoaderButton
            block
            bsStyle="primary"
            bsSize="large"
            onClick={this.showDatePicker}
            type="submit"
            isLoading={this.state.isLoading}
            text="Choose Another Date"
            loadingText="Loading Locations…"
          />
        )}
        {this.state.showPicker && (
          <Grid style={{ minHeight: '100vh' }}>
            <Row className="text-center" style={{ marginBottom: '15px' }}>
              <DatePicker
                onChange={this.handleDateChangeV2}
                value={this.state.currentDate}
              />
            </Row>
            <Row className="text-center">
              <Button
                bsStyle="primary"
                bsSize="large"
                onClick={this.getReportData}
              >
                {' '}
                Search{' '}
              </Button>
            </Row>
          </Grid>
        )}
        {!this.state.isLoading && (
          <Table bordered responsive>
            <thead>{headers}</thead>
            <tbody>{rows}</tbody>
          </Table>
        )}
      </div>
    );
  }
}
